import { AxiosResponse } from "axios";
import { put, call, takeLatest, select, delay } from "redux-saga/effects";
import { restaurantActions, successRestaurantDetails, failedRestaurantDetails, successRestaurantMenuDetails} from "../restaurant/restaurantAction";
import { getRestaurantDetails, getRestaurantMenuDetails, getRestaurantMenuDetails1 } from "../restaurant/restaurantAPI";
import {  RestaurantDetailRequest, RestaurantMenuRequest, RestaurantMenuResponse} from "../restaurant/restaurantModels";
import { getEventDate, getEventSlug, getLocationSlug } from "../selectors";
import { PERFORM_TASK, SYNC_MENU_TASK } from "./SchedulerConstants";
import { decryptJson } from "../../utils/react-ec-utils";
import { Store } from "../../configureStore";
import { getAvailableCatgorySubCategory,getAvailableCatgorySubCategory1 } from "../../utils/menu-helper-utils";
import { storeCartRestaurantDetails } from "../cart/cartActions";
import { UPDATE_CURRENT_ACTIVE_MENU } from "../restaurant/restaurantContants";

function* getRestaurantDetailsSaga(action: any) {
      const currentActivMenuType = (Store as any).getState().restaurant.currentActivMenuType;
    let payload = action.payload as RestaurantDetailRequest;
    const eventSlug: string | null = yield select(getEventSlug);
    const eventDate: boolean = yield select(getEventDate);
    const isEventOrder = Boolean(eventDate) || Boolean(eventSlug);

    const locationSlug: string | null = yield select(getLocationSlug);

    if(!locationSlug){
        if (payload?.sagaCallBack != null && typeof payload?.sagaCallBack === 'function') {
            payload.sagaCallBack(false, 1, 1, '');
        }
        return;
    }

    try {
       
        let restaurantDetails: any = null;
        const response: AxiosResponse = yield call(getRestaurantDetails, locationSlug as string);
        if (response.status === 200) {
            const decryptdata = decryptJson(response.data.encryptedText)
            decryptdata.isProductCatalogV2Enabled = true;
            yield put(successRestaurantDetails({ detail: decryptdata, isEventOrder }));
            restaurantDetails=decryptdata;

            if (payload?.sagaCallBack != null && typeof payload?.sagaCallBack === 'function') {
              
                
                payload.sagaCallBack(true, decryptdata?.deliveryCutOffTimeExceeds, decryptdata?.pickupCutOffTimeExceeds, decryptdata);
            }

            const menuPaylaod = {
                type: payload?.menuType,
                locationId: payload?.restaurantId,
                customerId: null,
                searchText: null,
                visibleTo: "C",
                from:currentActivMenuType?"s":''
            } as RestaurantMenuRequest
            if (payload?.isMenuTriggerReq){
                yield delay(3000); 
                try{
                const restaurantMenu= restaurantDetails?.isProductCatalogV2Enabled ? getRestaurantMenuDetails : getRestaurantMenuDetails1
                const menuResponse: AxiosResponse = yield call(restaurantMenu, menuPaylaod as RestaurantMenuRequest);
                const currentActivMenuTypePaylod = (Store as any).getState().restaurant.currentActivMenuType;

                yield put({ type: UPDATE_CURRENT_ACTIVE_MENU, payload: currentActivMenuTypePaylod?currentActivMenuTypePaylod:payload?.menuType })
                if (menuResponse.status === 200) {
                    let responseData;
                    if(restaurantDetails?.isProductCatalogV2Enabled){
                        responseData = menuResponse.data as RestaurantMenuResponse;
                    }else{
                         responseData = decryptJson(menuResponse.data.encryptedText) as RestaurantMenuResponse;
}
                    const { categoryTypes, subCategoryTypes } = restaurantDetails?.isProductCatalogV2Enabled? getAvailableCatgorySubCategory(responseData.menu):getAvailableCatgorySubCategory1(responseData.menu);
                
                    
                    yield put(storeCartRestaurantDetails((Store as any).getState().restaurant.currentRestaurantDetail, responseData.orderTax || [], responseData.defaultItemTax));
                    const rData = { ...responseData, categoryTypes, subCategoryTypes }
                    yield put(successRestaurantMenuDetails(rData));
                    yield put({ type: SYNC_MENU_TASK });
                }
                }catch(err){
                    yield put(failedRestaurantDetails({ message: "Please Try Again", isEventOrder }));
                }
            }
        } else {
            yield put(failedRestaurantDetails({ message: "Please Try Again", isEventOrder }));
            if (payload?.sagaCallBack != null && typeof payload?.sagaCallBack === 'function') {
                payload.sagaCallBack(false, 1, 1, '');
            }
        }
    } catch (err) {
        yield put(failedRestaurantDetails({ message: "Please Try Again", isEventOrder }));
        if (payload?.sagaCallBack != null && typeof payload?.sagaCallBack === 'function') {
            payload.sagaCallBack(false, 1, 1, '');
        }
    }
}


export default function* schedularSaga() {
   yield takeLatest(PERFORM_TASK, getRestaurantDetailsSaga);
}
